export function omit(target, props) {
    if (!target) {
        return {};
    }
    return Object.fromEntries(Object.entries(target).filter(([key]) => !props.includes(key)));
}
